module.exports = __webpack_public_path__ + "static/img/game-logo-jdb.dc936c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-jdb.png
// module id = Jt/+
// module chunks = 0 1 2 3 4 5 6